/* 210 §1 — WHICH LIST A SIDEBAR ROW COUNTS, AND WHICH LISTS A SECTION IS DRAWN
   FROM. The sidebar's count and the section's screen are two of the places a
   list that could not load must say so (src/lib/listLoad.ts has the rule):
   these two tables are where each section names its lists — read by App's
   sidebar rows (and so the Persons flyout's, SideFlyPanel) and by its section
   switch (`renderContent`). The keys are the lists' `SK` keys. */
import { SK } from "../utils";

/** The list a sidebar row's count counts. */
export const NAV_COUNT_LISTS: Readonly<Partial<Record<string, readonly string[]>>> = {
  ag: [SK.ag],
  ca: [SK.ca],
  cc: [SK.cc],
  ju: [SK.ju],
  co2int: [SK.co],
  co2ext: [SK.co],
  cl: [SK.cl],
  cp: [SK.cp],
  op: [SK.op],
  ocu: [SK.ocu],
  oc: [SK.oc],
  ex: [SK.ex],
  me: [SK.me],
  ar: [SK.ar],
  op2: [SK.op2],
  lib: [SK.books],
  invoices: [SK.inv],
};

/** The lists a section's screen is drawn from — its own, and the ones it counts
 *  over: while one of them could not load, the section says so in its place.
 *  The dashboard is not here: each of its blocks says so for its own list
 *  (Dashboard.tsx), and its pickers for theirs (TypeaheadPicker's `lists`). */
export const SECTION_LISTS: Readonly<Partial<Record<string, readonly string[]>>> = {
  ...NAV_COUNT_LISTS,
  costs: [SK.ca, SK.cc, SK.te, SK.co, SK.inv],
  reports: [SK.ca, SK.cc, SK.cl, SK.co, SK.op, SK.ocu, SK.ex, SK.ju, SK.te, SK.ag, SK.tk, SK.inv],
  sched: [SK.co, SK.ag],
  places: [SK.co, SK.ag],
  archive: [SK.ca, SK.cc],
};
